import Vue from 'vue'
import Router from 'vue-router'
import Home from '../components/Home.vue'
import Brands from '../components/Brands.vue'
import Actions from '../components/Actions.vue'
import Products from '../components/Products.vue'
import Customers from '../components/customers/Customers.vue'
import EditCustomer from '../components/customers/EditCustomer.vue'
import BecomeCustomer from '../components/BecomeCustomer.vue'
import MyOrders from '../components/MyOrders.vue'
import Contact from '../components/Contact.vue'
import ShoppingCart from '../components/ShoppingCart.vue'
import Privacy from '../components/Privacy.vue'
import Prices from '../components/Prices.vue'
import ProductsImport from '../components/ProductsImport.vue'
import Browser from '../components/Browser.vue'
import Jobs from '../components/Jobs.vue'

Vue.use(Router)

export default new Router({
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home,
            meta: {
                permission: 'public'
            }
        },
        {
            path: '/merken',
            name: 'merken',
            component: Brands,
            meta: {
                permission: 'public'
            }
        },
        {
            path: '/aanbiedingen',
            name: 'aanbiedingen',
            component: Actions,
            meta: {
                permission: 'public'
            }
        },
        {
            path: '/producten',
            name: 'producten',
            component: Products,
            meta: {
                permission: 'public'
            }
        },
        {
            path: '/categorie/:id',
            name: 'categorie',
            component: Products,
            meta: {
                permission: 'public'
            }
        },
        {
            path: '/klanten',
            name: 'klanten',
            component: Customers,
            meta: {
                permission: 'btonly'
            }
        },
        {
            path: '/klanten/:id',
            name: 'klant',
            component: EditCustomer,
            meta: {
                permission: 'btonly'
            }
        },
        {
            path: '/mijnorders',
            name: 'mijnorders',
            component: MyOrders,
            meta: {
                permission: 'btonly|customer'
            }
        },
        {
            path: '/klantworden',
            name: 'klantworden',
            component: BecomeCustomer,
            meta: {
                permission: 'public'
            }
        },
        {
            path: '/contact',
            name: 'contact',
            component: Contact,
            meta: {
                permission: 'public'
            }
        },
        {
            path: '/winkelwagen',
            name: 'winkelwagen',
            component: ShoppingCart,
            meta: {
                permission: 'public'
            }
        },
        {
            path: '/privacy',
            name: 'privacy',
            component: Privacy,
            meta: {
                permission: 'public'
            }
        },
        {
            path: '/prijzen',
            name: 'prijzen',
            component: Prices,
            meta: {
                permission: 'btonly'
            }
        },
        {
            path: '/productenimporteren',
            name: 'productenimporteren',
            component: ProductsImport,
            meta: {
                permission: 'btonly'
            }
        },
        {
            path: '/browser',
            name: 'browser',
            component: Browser,
            meta: {
                permission: 'public'
            },
            props: { browserName: 'Internet Explorer' }
        },
        {
            path: '/vacatures',
            name: 'vacatures',
            component: Jobs,
            meta: {
                permission: 'public'
            }
        },
    ]
})
